module.exports = __webpack_public_path__ + "img/toast-warn.899bd001.svg";